import { TranslationsContext } from '@teliaee/telia-translate';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsTrigger, Button, Grid, GridColumn, Text } from 'telia-front-react';
import { useStores } from '../stores/RootStore';
import { previewTime, renderLabelAndValue } from './common/FormatUtil';

const ReservationPreview = observer((): React.JSX.Element => {
  const {
    reservationStore: { reservationCreation, selectedBranchName, requireTechnician, reservationCreationState, createReservation, branchHasTechChild },
    countryCallingCodeStore: { countryCallingCode, isForeignCodeSelected },
  } = useStores();
  const { translate } = React.useContext(TranslationsContext);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Text spacing="double">
      <b>{translate('reservation.preview')}</b>
      {renderLabelAndValue(translate('reservation.preview.branch'), selectedBranchName)}
      {branchHasTechChild &&
        renderLabelAndValue(translate('reservation.preview.technical'), translate(`reservation.preview.technical.${requireTechnician ? 'yes' : 'no'}`))}
      {!!reservationCreation.description && renderLabelAndValue(translate('reservation.preview.description'), reservationCreation.description)}
      {!isForeignCodeSelected && renderLabelAndValue(translate('form.fields.phone'), `${countryCallingCode} ${reservationCreation.phone}`)}
      {isForeignCodeSelected && renderLabelAndValue(translate('form.fields.email'), reservationCreation.email)}
      {renderLabelAndValue(translate('reservation.preview.time'), previewTime(reservationCreation.time, translate('reservation.preview.timePrefix')))}
      <Grid align={['between-xs', 'middle-xs']}>
        <GridColumn width={['xs-6']}>
          <AnalyticsTrigger
            trigger={{
              id: 'Button - Change appointment details',
              callback: 'onClick',
            }}
          >
            <Button
              iconLeft="#arrow-left"
              variant="secondary"
              onClick={() => runInAction(() => (reservationCreationState.status = 'BEING_FILLED'))}
              text={translate('reservation.preview.change')}
              link={true}
            />
          </AnalyticsTrigger>
        </GridColumn>
        <GridColumn width={['xs-6']}>
          <AnalyticsTrigger trigger={{ id: 'Button - Book appointment', callback: 'onClick' }}>
            <Button
              iconRight="#arrow-right"
              disabled={reservationCreationState.status === 'SENDING'}
              onClick={createReservation}
              text={translate('reservation.submit')}
            />
          </AnalyticsTrigger>
        </GridColumn>
      </Grid>
    </Text>
  );
});

export default ReservationPreview;
